var map = {
	"./images/couple.jpg": 8,
	"./images/couple@2x.jpg": 9,
	"./images/doctor2.jpg": 10,
	"./images/doctor2@2x.jpg": 11,
	"./images/doctor3.jpg": 12,
	"./images/doctor3@2x.jpg": 13,
	"./images/doctor4.jpg": 14,
	"./images/doctor4@2x.jpg": 15,
	"./images/end-cta.jpg": 16,
	"./images/end-cta@2x.jpg": 17,
	"./images/ge-healthcare-logo.svg": 18,
	"./images/graphics/1-1-mask.png": 19,
	"./images/graphics/1-2-character.png": 20,
	"./images/graphics/1-3-cross.png": 21,
	"./images/graphics/1-4-dots.png": 22,
	"./images/graphics/2-1-mask-.png": 23,
	"./images/graphics/2-1-mask.png": 24,
	"./images/graphics/2-2-character.png": 25,
	"./images/graphics/2-3-line.png": 26,
	"./images/graphics/2-4-circles.png": 27,
	"./images/graphics/3-1-mask.png": 28,
	"./images/graphics/3-2-character.png": 29,
	"./images/graphics/3-3-microscope.png": 30,
	"./images/graphics/3-4-line.png": 31,
	"./images/graphics/3-5-circle.png": 32,
	"./images/graphics/4-1-mask.png": 33,
	"./images/graphics/4-2-character.png": 34,
	"./images/graphics/4-3-circle.png": 35,
	"./images/graphics/5-1-mask.png": 36,
	"./images/graphics/5-2-character.png": 37,
	"./images/graphics/5-3-circle.png": 38,
	"./images/graphics/6-1-mask.png": 39,
	"./images/graphics/6-2-character.png": 40,
	"./images/graphics/6-3-circle.png": 41,
	"./images/graphics/l1.png": 42,
	"./images/graphics/l2.png": 43,
	"./images/graphics/l3.png": 44,
	"./images/graphics/l4.png": 45,
	"./images/graphics/l5.png": 46,
	"./images/logo_cnn.svg": 47,
	"./images/share.jpg": 48,
	"./images/video-poster.jpg": 49,
	"./images/video-poster@2x.jpg": 50,
	"./video/loop.mp4": 51,
	"./video/loop2.mp4": 52
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;


//////////////////
// WEBPACK FOOTER
// ./src/media ^\.\/.*\.*
// module id = 63
// module chunks = 0